import { inject, Injectable } from "@angular/core";
import { ExcelValidationResult } from "@models/ExcelValidationResult";
import * as XLSX from 'xlsx';
import { CommonService } from "./common.service";
import { MandatoryColumns } from "@models/MandatoryColumns";
import { Obj } from "@popperjs/core";

@Injectable({
    providedIn: 'root',
})
export class ExcelValidateService {
    commonService = inject(CommonService);
    validateEXCELFiles(fileReader: FileReader, file: File, mandatoryColumns: MandatoryColumns[], evResult: ExcelValidationResult) {
        fileReader.readAsArrayBuffer(file)
        fileReader.onload = () => {
            let rowNo = 1;
            const arrayBuffer: ArrayBuffer = fileReader.result as ArrayBuffer;
            const data = new Uint8Array(arrayBuffer);
            const arr = [];
            for (let i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
            const bstr = arr.join("");
            const workbook = XLSX.read(bstr, { type: "binary" });
            const first_sheet_name = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[first_sheet_name] as XLSX.Sheet;
            this.trimWorksheetRange(worksheet);
            //const isFirstTime = true;
            const jsonRow = XLSX.utils.sheet_to_json(worksheet, { raw: true, defval: null, blankrows: true });
            if (jsonRow.length <= 0) {
                evResult.isValid = false;
                evResult.errorMsg.push('No data found!');
                this.commonService.validateExcelSubject.next(evResult);
                return;
            }
            //validate columns start
            const objKeys = Object.keys(jsonRow[0]!);
            for (const mc of mandatoryColumns) {
                if (!objKeys.includes(mc.displayName)) {
                    evResult.isValid = false;
                    evResult.errorMsg.push('* Column: ' + mc.displayName + ' is not present in excel!');
                }
            }
            let allHeaderValid=true;
            const headers=Object.keys(jsonRow[0]!);
            for(const header of headers){
                const headerExist=mandatoryColumns.some((m)=>m.displayName==header);
                if(!headerExist){
                    allHeaderValid=false;
                    evResult.isValid = false;
                    if(header.includes('__EMPTY')){
                        evResult.errorMsg.push('* Uploaded File has a blank column');
                    }else{
                        evResult.errorMsg.push('* Uploaded File has an invalid column: '+header);
                    }
                    
                }
            }
            if(!allHeaderValid){
                 this.commonService.validateExcelSubject.next(evResult);
                 return;
            }
            if (!evResult.isValid) {
                this.commonService.validateExcelSubject.next(evResult);
                return;
            }
            //validate columns end

            //validate data
            for (const row of jsonRow) {
                let anyCellHasValue = false;
                rowNo += 1;
                for (const mc of mandatoryColumns) {
                    const rowObj = row as Obj;
                    const key = mc.displayName;
                    const value = rowObj[key];
                    if (value) {
                        anyCellHasValue = true;
                        //check regex
                        if (mc.regexp instanceof RegExp) {
                            const isValid = mc.regexp.test(value);
                            if (!isValid) {
                                evResult.isValid = false;
                                evResult.errorMsg.push('* Column: ' + key + ' has not valid value on row number ' + rowNo);
                            }
                        }
                        //check min
                        if (mc.minLength > 0) {
                            if (value.length < mc.minLength) {
                                evResult.isValid = false;
                                evResult.errorMsg.push('* Column: ' + key + ' has not valid minimum length on row number ' + rowNo);
                            }
                        }
                        //check max
                        if (mc.maxLength > 0) {
                            if (value.length > mc.maxLength) {
                                evResult.isValid = false;
                                evResult.errorMsg.push('* Column: ' + key + ' has not valid maximum length on row number ' + rowNo);
                            }
                        }

                    }
                }
                if (!anyCellHasValue) {
                    evResult.isValid = false;
                    evResult.errorMsg.push('* Row number: ' + rowNo + ', at least a single cell should have value');
                }
            }
            if (!evResult.isValid) {
                this.commonService.validateExcelSubject.next(evResult);
                return;
            }
            //validate data end

            // const rCount = jsonRow.length;
            // console.log(jsonRow);
            // console.log(rCount);
            // console.log(mandatoryColumns);
            this.commonService.validateExcelSubject.next(evResult);
        }
    }
    trimWorksheetRange(worksheet: XLSX.Sheet): void {
        const range = worksheet['!ref'];
        if (!range) return;

        const [startCell, endCell] = range.split(':');
        const startCol = startCell.match(/[A-Z]+/)?.[0] || 'A';
        const endCol = endCell.match(/[A-Z]+/)?.[0] || 'ZZ';
        const maxRow = parseInt(endCell.match(/\d+/)?.[0] || '0');

        let lastDataRow = 0;

        for (let row = 1; row <= maxRow; row++) {
            for (let colCode = startCol.charCodeAt(0); colCode <= endCol.charCodeAt(0); colCode++) {
                const cellAddress = `${String.fromCharCode(colCode)}${row}`;
                const cell = worksheet[cellAddress];
                if (cell && cell.v !== undefined && cell.v !== null && cell.v.toString().trim() !== '') {
                    lastDataRow = row;
                    break;
                }
            }
        }

        if (lastDataRow > 0) {
            worksheet['!ref'] = `${startCol}1:${endCol}${lastDataRow}`;
        }
    }
}


